import { createElementVNode as _createElementVNode, openBlock as _openBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "p-6"
};
const _hoisted_2 = {
  class: "px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3"
};
const _hoisted_3 = ["disabled"];
import { ref, reactive, watch } from 'vue';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'CircleRejectModal',
  props: {
    show: Boolean,
    postId: Number
  },
  emits: ['update:show', 'confirm'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const form = reactive({
      rejectReason: ''
    });
    const submitting = ref(false);
    watch(() => props.show, val => {
      if (val) {
        form.rejectReason = '';
      }
    });
    const handleClose = () => {
      emit('update:show', false);
    };
    const handleSubmit = () => {
      if (!form.rejectReason.trim()) {
        return;
      }
      submitting.value = true;
      emit('confirm', {
        id: props.postId,
        rejectReason: form.rejectReason.trim()
      });
    };
    const done = () => {
      submitting.value = false;
      handleClose();
    };
    __expose({
      done
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: __props.show,
          size: "md",
          scrollable: false,
          onClose: handleClose
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between"
          }, [_cache[2] || (_cache[2] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "审核拒绝", -1)), _createElementVNode("button", {
            onClick: handleClose,
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
          }, [...(_cache[1] || (_cache[1] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, [_createTextVNode(" 拒绝原因 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.rejectReason = $event),
            rows: "4",
            placeholder: "请输入拒绝原因",
            class: "form-textarea"
          }, null, 512), [[_vModelText, form.rejectReason]])]), _createElementVNode("div", _hoisted_2, [_createElementVNode("button", {
            onClick: handleClose,
            class: "btn-secondary"
          }, " 取消 "), _createElementVNode("button", {
            onClick: handleSubmit,
            disabled: submitting.value || !form.rejectReason.trim(),
            class: "btn-danger-secondary"
          }, _toDisplayString(submitting.value ? '提交中...' : '确认拒绝'), 9, _hoisted_3)])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })]);
    };
  }
};